import React, {useContext, useEffect, useState} from 'react';
import {Route, Switch} from 'react-router-dom';
import {AppContext} from '../../context/app/appContext';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import ProgressBar from './ProgressBar';
import axios from 'axios'

export const TotalTransactions = (props) => {
    const appContext = useContext(AppContext)

    const [transactionsList,setTransactionsList] = useState([]);
    const [totalTransactions,setTotalTransactions] = useState(0);
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const accessToken = localStorage.getItem('accessToken');   

    useEffect(() => {
        (async function saveTotalTransactions(){
            await appContext.transactionsList() 
        })()

    }, [])
    useEffect(()=>{
        console.log(appContext.totalTransaction)
        setTransactionsList(appContext.totalTransaction)
        setTotalTransactions(appContext.totalTransaction.length)
    },[appContext.totalTransaction])
    
    return (
        <div style={{width: "100%", height: "100%", display: "flex", flexDirection: "row", marginLeft: 10, marginRight: 10}}>
            <div style={{flex: 0}}>
                <ProgressBar
                    percentage={10}
                    startColor="rgba(0, 200, 136, 1)"
                    endColor="rgba(0, 100, 68, 1)"
                    gradientId="progress"
                    // value = {parseInt(totalTransactions*100/100)}
                    value = {80}
                >
                    <div style={{color: 'rgba(133, 133, 133, 1)', fontSize: 14, fontStyle: 'SFProText-Bold',
                            background: "-webkit-linear-gradient(rgba(0, 200, 136, 1), rgba(0, 0, 0, 1))", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", }}>
                        {/* {totalTransactions} */}
                        80
                    </div>
                </ProgressBar>
            </div>
                <div style={{alignItems: 'center', justifyContent: 'center', flex: 1, display: 'flex', flexDirection: 'column', flexWrap: 'wrap'}}>
                    <div style={{color: 'rgba(133, 133, 133, 1)', fontStyle:'SFProText-Bold', fontSize: 16, marginBottom: 10, textAlign: 'center'}}>Budget Used</div>
                    {/* <div style={{color: 'rgba(28, 209, 161, 1)', fontStyle:'SFProText-Bold', fontSize: 20, marrginTop: 10}}>{parseInt(totalTransactions*100/100)}%</div> */}
                    <div style={{color: 'rgba(28, 209, 161, 1)', fontStyle:'SFProText-Bold', fontSize: 20, marrginTop: 10}}>80 %</div>
                </div>
        </div>
    );
};
